import styled from "styled-components";

const ModalContainer = styled.div`
    padding: 15px;
    .form-item {
        input,
        select,
        textarea {
            width: 100%;
            line-height: 2;
            padding: 8px 10px;
            background: #fdfdfd;
            border: solid 1px #cccc;
            border-radius: 5px;
            margin-bottom: 20px;
            font-size: 16px;
            &.disabled {
                pointer-events: none !important;
            }
        }
        input,
        select {
            height: 48px;
        }
        input[type="checkbox"],
        input[type="radio"] {
            height: 15px;
            width: 15px;
            margin-bottom: 0px;
            &:not(:last-child) {
                margin-bottom: 18px;
            }
            + span {
                top: -1.5px;
            }
        }

        .error-msg {
            top: 75px;
        }

        .icon {
            top: 33px;
            right: 13px;
            font-size: 20px;
        }
    }

    .password-field {
        input {
            padding-right: 40px;
        }
    }

    button[type="submit"] {
        min-height: 48px;
        background-color: #333;
        color: #fff;
        font-size: 17px;
        transition: 0.2s;
        min-width: 200px;
        box-shadow: none !important;
    }

    padding-right: 0;
    padding-bottom: 0;

    .addresses-view {
        .address-item {
            @media (max-width: 500px) {
                width: 100%;
            }
            margin: 0 15px 15px 0;
            > .inner {
                border: 1px solid #ddd;
                padding: 10px 15px;
                background: #f4f4f4;
                border-radius: 5px;
                width: 200px;
                height: 100%;
                @media (max-width: 500px) {
                    width: 100%;
                }
                .is-default {
                    background: #ddd;
                    padding: 3px 6px 2px;
                    border-radius: 5px;
                    align-self: flex-start;
                    font-weight: 600;
                }
                .address {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                &:hover {
                    background: #f0f0f0;
                }
            }
            .btn {
                background: #000;
                color: #fff;
                font-size: 14px;
                border-radius: 5px;
                width: 100%;
                margin-top: auto;
            }
        }

        .add-new-address {
            > .inner {
                padding: 20px 15px;
            }
        }
    }
`;
export default ModalContainer;
